(function () {
  var targets = document.querySelectorAll(
    ".lp-section .fade-in:not(.is-visible)",
  );
  if (!targets.length) return;

  var reveal = function (el) {
    el.classList.add("is-visible");
  };

  if (!("IntersectionObserver" in window)) {
    targets.forEach(reveal);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: "0px 0px -10% 0px",
      threshold: 0.1,
    },
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();
